<!-- 会员列表 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">会员列表</div>
      </div>
      <div class="content ">
        <el-table
          height="68vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="AdminList.list"
          style="width: 100%"
        >
          <el-table-column prop="adUname" label="账号" width="210">
          </el-table-column>
          <el-table-column prop="adName" label="管理者" width="210">
          </el-table-column>
          <el-table-column label="状态" width="210">
            <template slot-scope="scope">
              {{ scope.row.adActivate | IsFalse('停用', '激活') }}
            </template>
          </el-table-column>
          <el-table-column prop="adRegister" label="登录时间" width="230">
          </el-table-column>
          <el-table-column label="编辑">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >修改</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ AdminList.total }}条记录，</span>
            <span class="pageNum">{{ AdminList.pageNum }}</span>
            <span>/{{ AdminList.pages }}页</span>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="AdminList.pageNum"
            :page-size="AdminList.pageSize"
            layout="prev, pager, next, jumper"
            :total="AdminList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogAdmin"
        width="30%"
        :before-close="dialogAdminClose"
      >
        <span slot="title">
          <span class="header-main-title">{{ dialogTitle }}</span>
        </span>
        <div class="adminForm textalignLeft">
          <el-form ref="adminForm" :model="adminForm" label-width="80px">
            <el-form-item label="用户名">
              <el-input v-model="adminForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机账号">
              <el-input v-model="adminForm.tel"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" v-if="!isEdit">
              <el-input v-model="adminForm.Password"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址">
              <el-input v-model="adminForm.email"></el-input>
            </el-form-item>
            <el-form-item label="可用状态">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                v-model="adminForm.activate"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogAdmin = false">取 消</el-button>
          <el-button type="primary" @click="dialogAdminBut">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { apiClubCardIndex } from '@/api/fitness'
// import { objNaN } from '@/utils'

export default {
  name: '',
  props: [''],
  data() {
    return {
      AdminList: [],
      page: '1', // 页数
      dialogAdmin: false,
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      adminForm: {
        name: '',
        tel: '',
        Password: '',
        activate: 0
      },
      adminFormEmail: '',
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetAdminList()
  },

  methods: {
    // 列表删除
    delBut(row) {},
    // 列表修改
    editBut(row) {
      console.log(row)
      this.isEdit = true
      this.adId = row.adId
      this.adminForm.name = row.adName
      this.adminForm.tel = row.adUname
      this.adminForm.activate = row.adActivate
      this.adminFormEmail = row.adEmail
      this.dialogTitle = '修改管理员'
      this.dialogAdmin = true
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val
      console.log(`当前页: ${val}`)
      this.GetAdminList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    // 接口
    // 获取管理人员列表
    ClubCardIndex() {
      apiClubCardIndex({
        page: this.page,
        pageSize: 20
      }).then(res => {
        if (res.status === 0) {
          this.AdminList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
